import type { FaireProductEntity } from "../../entity_types/product";

export const p_dsjdub24z4: FaireProductEntity = {
  token: "p_dsjdub24z4",
  type: "product",
  name: "Green Christmas Tree Beaded Statement Earrings (Copy)",
  brandToken: "b_vjqfbthsp3",
  brandName: "Brookhaven Baubles",
  imageUrl: "https://cdn.faire.com/fastly/231e4dce0bf03ebeb3030962e517d2b6625f11c2ef7ab6377116eb08bd7f930c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6f1e72460083399df7abf925f4ddd0f392a09a1252fbe4a320140a6133c69e45.jpeg",
    "https://cdn.faire.com/fastly/e67a29b1ab99c642406fb054b76baaaadd058c02f32011eee90d9c983c708b0b.jpeg",
    "https://cdn.faire.com/fastly/590c5c2cb1efcbed70e03527e7b185505d35b92a1b6259e7fa3d476b738d8c62.jpeg",
    "https://cdn.faire.com/fastly/aabf24b0290df689056df83d865f5fa15f2ca52a7277835e252ecff55a09b371.jpeg"
  ],
  priceDollars: 14,
  description: "Green Christmas Tree Beaded Earrings - Brookhaven Baubles Southern Statement Jewelry - Christmas Earrings\n\nWhite Christmas Tree Beaded Earrings - Brookhaven Baubles Southern Statement Jewelry - Christmas Earrings - Fashion Earrings for Her \n\nThese lightweight earrings that you will practically forget you are wearing them.\n\nOur earrings are the perfect statement for any occasion or outfit! Perfect for every occasion, from casual days to special events like weddings and birthdays. Get a pair for yourself, your bestie, or as a gift!\n\nAll posts are lead and nickel-free and very lightweight for easy everyday wear.\n\n\n\nAll images are copyrighted by Brookhaven Baubles. All rights reserved.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T16:32:08.601Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
